/* Saéa Homes gallery lightbox.
   Scoped to .saea-homes — it binds nothing if the page isn't present. */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.saea-homes');
    if (!root) return;

    var dialog = root.querySelector('.saea-homes__lightbox');
    var cells = Array.prototype.slice.call(root.querySelectorAll('[data-saea-homes-full]'));
    if (!dialog || !cells.length || typeof dialog.showModal !== 'function') return;

    var img = dialog.querySelector('.saea-homes__lightbox-img');
    var count = dialog.querySelector('.saea-homes__lightbox-count');
    var prev = dialog.querySelector('.saea-homes__lightbox-nav--prev');
    var next = dialog.querySelector('.saea-homes__lightbox-nav--next');
    var closeBtn = dialog.querySelector('.saea-homes__lightbox-close');
    var index = 0;
    var opener = null;

    function show(i) {
      index = (i + cells.length) % cells.length;
      var cell = cells[index];
      img.src = cell.getAttribute('data-saea-homes-full');
      img.alt = cell.getAttribute('data-saea-homes-alt') || '';
      count.textContent = index + 1 + ' / ' + cells.length;
    }

    function open(i) {
      opener = cells[i];
      show(i);
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    cells.forEach(function (cell, i) {
      cell.addEventListener('click', function () {
        open(i);
      });
    });

    prev.addEventListener('click', function () {
      show(index - 1);
    });
    next.addEventListener('click', function () {
      show(index + 1);
    });
    closeBtn.addEventListener('click', close);

    // Backdrop click closes; clicks on the image or controls must not.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + 1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(index - 1);
      }
    });

    // Esc fires 'close' natively; restore scroll and focus either way.
    dialog.addEventListener('close', function () {
      document.body.style.overflow = '';
      if (opener) opener.focus();
    });

    // Swipe between images on touch.
    var startX = null;
    dialog.addEventListener(
      'touchstart',
      function (event) {
        startX = event.changedTouches[0].clientX;
      },
      { passive: true }
    );
    dialog.addEventListener(
      'touchend',
      function (event) {
        if (startX === null) return;
        var dx = event.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) show(dx < 0 ? index + 1 : index - 1);
        startX = null;
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
